/** A point in screen pixels, as mapbox reports one on a pointer event. */
export interface ScreenPoint {
  x: number;
  y: number;
}

/**
 * Below this many pixels of travel the pointer was aimed, not dragged. Wide enough to
 * absorb the hand tremor of a click, narrow enough that a deliberate nudge still routes.
 */
export const DRAG_THRESHOLD_PX = 4;

/**
 * Whether a press-and-release moved far enough to mean "re-route through here" rather than
 * "I clicked".
 *
 * Without the threshold every click is a drag, which costs a billable provider request per
 * click and makes removing a via impossible: a double click delivers two zero-movement
 * mouseups before its dblclick, and the first of them leaves a request in flight that the
 * removal is then refused for.
 */
export function isDragGesture(
  down: ScreenPoint,
  up: ScreenPoint,
  thresholdPx: number
): boolean {
  return Math.hypot(up.x - down.x, up.y - down.y) >= thresholdPx;
}
